import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  question: '¿Para quién es este pack?',
  answer: 'Está diseñado específicamente para mujeres que sienten que las finanzas no son lo suyo, que viven al día o tienen ingresos variables. No necesitas conocimientos previos de contabilidad ni matemáticas.'
}, {
  question: '¿Necesito mucho tiempo para aplicarlo?',
  answer: 'No. El método está creado para mujeres ocupadas. El reto de 30 días solo requiere 15 minutos diarios de lectura y ejercicios prácticos.'
}, {
  question: '¿Sirve si tengo ingresos variables?',
  answer: '¡Absolutamente! De hecho, es ideal para ti. Incluimos estrategias específicas para manejar la incertidumbre de los ingresos variables (freelancers, emprendedoras, ventas).'
}, {
  question: '¿Cómo recibo el material?',
  answer: 'Es un producto 100% digital. Inmediatamente después de tu compra, recibirás un correo con el acceso a la plataforma donde podrás descargar todos los PDFs y guías.'
}, {
  question: '¿Tengo que imprimir todo?',
  answer: "No es obligatorio. Los PDFs son interactivos y puedes llenarlos desde tu computadora o tablet. Sin embargo, recomendamos imprimir el 'Diario de Dinero' para tener una experiencia más tangible."
}, {
  question: '¿Incluye asesoría personalizada?',
  answer: 'Este es un pack de autoestudio diseñado para ser muy claro y fácil de seguir por tu cuenta. No incluye sesiones 1 a 1, pero el material cubre las dudas más frecuentes paso a paso.'
}];
export function FAQ() {
  const [activeIndex, setActiveIndex] = useState<number | null>(null);
  return <section className="py-20 bg-gray-50" data-id="element-53">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-54">
        <div className="text-center mb-12" data-id="element-55">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-[#1e3a5f] mb-4" data-id="element-56">
            Preguntas Frecuentes
          </h2>
          <p className="text-gray-600" data-id="element-57">
            Resolvemos tus dudas para que tomes la mejor decisión.
          </p>
        </div>

        <div className="space-y-4" data-id="element-58">
          {faqs.map((faq, index) => <div key={index} className="bg-white rounded-xl border border-gray-200 overflow-hidden shadow-sm hover:shadow-md transition-shadow" data-id="element-59">
              <button onClick={() => setActiveIndex(activeIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-60">
                <span className="font-bold text-[#1e3a5f] text-lg" data-id="element-61">
                  {faq.question}
                </span>
                <ChevronDown className={`w-5 h-5 text-[#d4a574] transition-transform duration-300 ${activeIndex === index ? 'transform rotate-180' : ''}`} data-id="element-62" />
              </button>

              <AnimatePresence data-id="element-63">
                {activeIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-64">
                    <div className="px-6 pb-6 text-gray-600 leading-relaxed border-t border-gray-100 pt-4" data-id="element-65">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}